import { apiCallback } from 'api';
import { ApiCallArgs } from 'api/types';

const baseDefinition = {
  service: 'content-experience',
  endpoint: 'content',
  verbs: ['get'],
  defaultVersion: 1,
};

export type ContentExperienceServiceCallbackArgs = {
  resourcePath: string;
  cache?: {
    memoryCacheMaxAge: number;
  };
} & ApiCallArgs;

const buildGetApiCallback = ({
  resourcePath,
  cache,
  ...apiCallArgs
}: ContentExperienceServiceCallbackArgs) => {
  const apiDefinition = {
    ...baseDefinition,
    query: {
      resourcePath,
    },
    ...(cache && {
      memoryCacheKey: `content[${resourcePath}]`,
      memoryCacheMaxAge: cache.memoryCacheMaxAge,
    }),
  };

  return apiCallback(apiDefinition, 'get')({ iHandleStatusCodes: true, ...apiCallArgs });
};

export default {
  get: buildGetApiCallback,
};
